const showMoreBtn = document.getElementById("showMoreBtn");
let visibleCount = 6;

function getBoxes() {
    return Array.from(document.querySelectorAll(".testimonial-box"));
}

function showTestimonials() {
    const boxes = getBoxes().filter(
        box => box.dataset.hidden !== "true"
    );

    getBoxes().forEach(box => {
        box.style.display = "none";
    });

    boxes.forEach((box, i) => {
        if (i < visibleCount) {
            box.style.display = "block";
        }
    });

    showMoreBtn.style.display =
        visibleCount >= boxes.length ? "none" : "block";
}

function sortBoxes(value) {
    const wrapper = document.querySelector(".reviews_sec .container");
    const btn = showMoreBtn.parentElement;

    let boxes = getBoxes();

    // Reset hidden state
    boxes.forEach(box => {
        box.dataset.hidden = "false";
    });

    if (value === "pineal-xt" || value === "pineal-guardian") {

        // Filter products
        boxes.forEach(box => {
            if (box.dataset.product !== value) {
                box.dataset.hidden = "true";
            }
        });

    } else {

        // Sort
        boxes.sort((a, b) => {

            if (value === "featured") {
                const featuredDiff =
                    Number(b.dataset.featured) - Number(a.dataset.featured);

                if (featuredDiff !== 0) return featuredDiff;

                return Number(a.dataset.date) - Number(b.dataset.date);
            }

            if (value === "recent") {
                return Number(a.dataset.date) - Number(b.dataset.date);
            }

            if (value === "oldest") {
                return Number(b.dataset.date) - Number(a.dataset.date);
            }

            if (value === "highest") {
                const ratingDiff =
                    Number(b.dataset.rating) - Number(a.dataset.rating);

                if (ratingDiff !== 0) return ratingDiff;

                return Number(a.dataset.date) - Number(b.dataset.date);
            }

            return 0;
        });

        boxes.forEach(box => wrapper.insertBefore(box, btn));
    }

    visibleCount = 6;
    showTestimonials();
}

// Initial load
sortBoxes("featured");

// Show More
showMoreBtn.addEventListener("click", () => {
    visibleCount += 3;
    showTestimonials();
});

// Dropdown change
document.querySelector(".feature_txt").addEventListener("change", function () {
    sortBoxes(this.value);
});

//Text testimonials Slider 

    const track1 = document.querySelector(".slider-track");
    const slides1 = document.querySelectorAll(".slider-track .box1-testimonial");
    const prevBtn1 = document.getElementById("prevBtn1");
    const nextBtn1 = document.getElementById("nextBtn1");

    const dotsContainer1 = document.getElementById("dots");

    let index1 = 0;
    const visibleSlides1 = 3;
    const totalSlides1 = slides1.length;
    const maxIndex1 = totalSlides1 - visibleSlides1;

    /* create dots */

    for (let i = 0; i <= maxIndex1; i++) {

      let dot1 = document.createElement("span");

      if (i === 0) dot1.classList.add("active");

      dot1.addEventListener("click", () => {
        index1 = i;
        updateSlider1();
      });

      dotsContainer1.appendChild(dot1);
    }

    const dots1 = dotsContainer1.querySelectorAll("span");

    function updateSlider1() {

      const slideWidth = slides1[0].offsetWidth + 28; // 28 = gap

      track1.style.transform = `translateX(-${index1 * slideWidth}px)`;

      dots1.forEach(d => d.classList.remove("active"));
      dots1[index1].classList.add("active");

    }

    /* next button */

    nextBtn1.addEventListener("click", () => {

      if (index1 >= maxIndex1) {
        index1 = 0;
      } else {
        index1++;
      }

      updateSlider1();

    });

    /* prev button */

    prevBtn1.addEventListener("click", () => {

      if (index1 <= 0) {
        index1 = maxIndex1;
      } else {
        index1--;
      }

      updateSlider1();

    });

    function openPopup(id) {

      // close any open popup first
      document.querySelectorAll(".popup-overlay").forEach(popup => {
        popup.style.display = "none";
      });

      // open selected popup
      document.getElementById(id).style.display = "flex";
    }

    function closePopup(id) {
      document.getElementById(id).style.display = "none";
    }
    if (window.innerWidth <= 600) {
      // Make the slider scrollable and snap
      track1.style.overflowX = "auto";
      track1.style.scrollSnapType = "x mandatory";
      slides1.forEach(card => (card.style.scrollSnapAlign = "start"));

      // Remove old dots and recreate 1 dot per slide
      dotsContainer1.innerHTML = "";
      slides1.forEach((slide, i) => {
        const dot = document.createElement("span");
        if (i === 0) dot.classList.add("active");
        dotsContainer1.appendChild(dot);
      });
      const dotsMobile = dotsContainer1.querySelectorAll("span");

      track1.addEventListener("scroll", () => {
        const cardWidth = slides1[0].offsetWidth + 28;
        let scrollIndex = Math.round(track1.scrollLeft / cardWidth);

        // Loop back to first if at last slide
        if (scrollIndex >= totalSlides1) {
          track1.scrollLeft = 0;
          scrollIndex = 0;
        }

        // Update dots
        dotsMobile.forEach(d => d.classList.remove("active"));
        if (dotsMobile[scrollIndex]) dotsMobile[scrollIndex].classList.add("active");
      });
    }



// ============================================================
// Review tiles now live directly in index.html as plain markup.
// This script only wires up behavior:
//   1. inline "play" for video tiles
//   2. the Read More / tile click -> modal
//   3. the modal's prev/next stage, thumbnail strip, and helpful votes
//   4. the show more / show less dropdown bar
// ============================================================

const grid = document.getElementById("reviewsGrid");
const expandBar = document.getElementById("gridExpandBar");
const tiles = Array.from(grid.querySelectorAll(".review-tile"));

// --- Read each tile's data straight from its data-* attributes ---
function readTileData(tile){
  return {
    name: tile.dataset.name,
    verified: tile.dataset.verified === "true",
    product: tile.dataset.product,
    productImg: tile.dataset.productImg, 
    rating: parseInt(tile.dataset.rating, 10) || 0,
    date: tile.dataset.date,
    title: tile.dataset.title,
    text: tile.querySelector(".hover-text")?.textContent.trim() || "",
    up: parseInt(tile.dataset.up, 10) || 0,
    down: parseInt(tile.dataset.down, 10) || 0,
    type: tile.dataset.type,
    imgSrc: tile.querySelector("img")?.getAttribute("src"),
    videoEl: tile.querySelector("video")
  };
}

function starString(rating, size = 5){
  let out = "";
  for(let i = 1; i <= size; i++){
    out += i <= rating ? "&#9733;" : "<span class=\"dim\">&#9733;</span>";
  }
  return out;
}

// --- Inline video play: clicking the play badge plays the video
//     right inside its tile instead of just linking to the modal ---
tiles.forEach((tile) => {
  const playBadge = tile.querySelector(".play-badge");
  const video = tile.querySelector("video");
  if(!playBadge || !video) return;

  playBadge.addEventListener("click", (e) => {
    e.stopPropagation(); // don't also trigger the modal
    video.muted = false;
    video.setAttribute("controls", "");
    video.play();
    tile.classList.add("is-playing");
  });

  // hide controls again once the clip ends, back to poster + play badge
  video.addEventListener("ended", () => {
    tile.classList.remove("is-playing");
    video.removeAttribute("controls");
  });

  // clicking the video itself while playing shouldn't reopen the modal
  video.addEventListener("click", (e) => e.stopPropagation());
});

// --- Open modal on tile click (including the Read More button) ---
tiles.forEach((tile, index) => {
  tile.addEventListener("click", () => openModal(index));
});

// --- Modal elements ---
const overlay = document.getElementById("modalOverlay");
const closeBtn = document.getElementById("modalClose");
const stageMedia = document.getElementById("stageMedia");
const stagePrev = document.getElementById("stagePrev");
const stageNext = document.getElementById("stageNext");
const thumbStrip = document.getElementById("thumbStrip");
const thumbPrev = document.getElementById("thumbPrev");
const thumbNext = document.getElementById("thumbNext");

const reviewerName = document.getElementById("reviewerName");
const verifiedBadge = document.getElementById("verifiedBadge");
const reviewingProduct = document.getElementById("reviewingProduct");
const reviewingProductImage = document.getElementById("reviewingProductImage");
const modalStars = document.getElementById("modalStars");
const reviewDate = document.getElementById("reviewDate");
const reviewTitle = document.getElementById("reviewTitle");
const reviewText = document.getElementById("reviewText");
const upCount = document.getElementById("upCount");
const downCount = document.getElementById("downCount");
const thumbUp = document.getElementById("thumbUp");
const thumbDown = document.getElementById("thumbDown");

let currentIndex = 0;
let votes = {}; // per-index { up: bool, down: bool }

function renderModal(index){
  currentIndex = index;
  const r = readTileData(tiles[index]);

  // stage media: real <video> with controls for video reviews, image otherwise
  if(r.type === "video" && r.videoEl){
    const source = r.videoEl.querySelector("source");
    stageMedia.innerHTML = `
      <video class="stage-video" controls playsinline poster="${r.videoEl.getAttribute("poster")}">
        <source src="${source ? source.src : ""}" type="video/mp4">
      </video>
    `;
  } else {
    stageMedia.innerHTML = `<img src="${r.imgSrc}" alt="Photo from ${r.name}'s review">`;
  }

  reviewerName.textContent = r.name;
  verifiedBadge.style.display = r.verified ? "inline-flex" : "none";
  reviewingProduct.textContent = r.product;
  reviewingProductImage.src = r.productImg;
  reviewingProductImage.alt = r.product;
  modalStars.innerHTML = starString(r.rating);
  reviewDate.textContent = r.date;
  reviewTitle.textContent = r.title;
  reviewText.textContent = r.text;

  const v = votes[index] || { up: 0, down: 0 };
  upCount.textContent = r.up + (v.up ? 1 : 0);
  downCount.textContent = r.down + (v.down ? 1 : 0);
  thumbUp.classList.toggle("active", !!v.up);
  thumbDown.classList.toggle("active", !!v.down);

  highlightThumb(index);
}

function buildThumbStrip(){
  thumbStrip.innerHTML = "";
  tiles.forEach((tile, i) => {
    const r = readTileData(tile);
    const t = document.createElement("div");
    t.className = "thumb-item";
    t.dataset.index = i;

    const thumbImgSrc = r.type === "video" ? r.videoEl.getAttribute("poster") : r.imgSrc;
    t.innerHTML = `
      <img src="${thumbImgSrc}" alt="${r.name}">
      ${r.type === "video" ? `<div class="play-badge"><svg width="18" height="18" viewBox="0 0 24 24" fill="#fff"><path d="M8 5v14l11-7z"/></svg></div>` : ""}
    `;
    t.addEventListener("click", () => renderModal(i));
    thumbStrip.appendChild(t);
  });
}

function highlightThumb(index){
  [...thumbStrip.children].forEach((el, i) => {
    el.classList.toggle("active", i === index);
  });
  const active = thumbStrip.children[index];
  if(active){
    active.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
  }
}

function openModal(index){
  buildThumbStrip();
  renderModal(index);
  overlay.classList.add("open");
  document.body.style.overflow = "hidden";
}

function stopStageVideo(){
  const v = stageMedia.querySelector("video");
  if(v) v.pause();
}

function closeModal(){
  stopStageVideo();
  overlay.classList.remove("open");
  document.body.style.overflow = "";
}

closeBtn.addEventListener("click", closeModal);
overlay.addEventListener("click", (e) => {
  if(e.target === overlay) closeModal();
});
document.addEventListener("keydown", (e) => {
  if(!overlay.classList.contains("open")) return;
  if(e.key === "Escape") closeModal();
  if(e.key === "ArrowRight") { stopStageVideo(); renderModal((currentIndex + 1) % tiles.length); }
  if(e.key === "ArrowLeft") { stopStageVideo(); renderModal((currentIndex - 1 + tiles.length) % tiles.length); }
});

stageNext.addEventListener("click", () => { stopStageVideo(); renderModal((currentIndex + 1) % tiles.length); });
stagePrev.addEventListener("click", () => { stopStageVideo(); renderModal((currentIndex - 1 + tiles.length) % tiles.length); });

thumbNext.addEventListener("click", () => { thumbStrip.scrollBy({ left: 160, behavior: "smooth" }); });
thumbPrev.addEventListener("click", () => { thumbStrip.scrollBy({ left: -160, behavior: "smooth" }); });

thumbUp.addEventListener("click", () => {
  const v = votes[currentIndex] || { up: 0, down: 0 };
  v.up = v.up ? 0 : 1;
  if(v.up) v.down = 0;
  votes[currentIndex] = v;
  renderModal(currentIndex);
});
thumbDown.addEventListener("click", () => {
  const v = votes[currentIndex] || { up: 0, down: 0 };
  v.down = v.down ? 0 : 1;
  if(v.down) v.up = 0;
  votes[currentIndex] = v;
  renderModal(currentIndex);
});

// --- Show more / show less toggle ---
const extraTileCount = tiles.filter(t => t.classList.contains("extra-tile")).length;
if (extraTileCount > 0) {
  expandBar.addEventListener("click", () => {
    const isExpanded = grid.classList.toggle("expanded");
    expandBar.setAttribute("aria-expanded", String(isExpanded));
    if (!isExpanded) {
      grid.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  });
} else {
  expandBar.style.display = "none";
}


document.addEventListener("DOMContentLoaded", function () {
    function updateButtons() {
        const buttons = document.querySelectorAll(".review-tile[data-type='video'] .read-more-btn");

        buttons.forEach(button => {
            if (window.innerWidth <= 720) {
                button.textContent = "Watch Video";
            } else {
                button.textContent = "Read More";
            }
        });
    }

    updateButtons();
    window.addEventListener("resize", updateButtons);
});




